import React from 'react';
import PropTypes from 'prop-types';

export default function SortIcon(props) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M20 9H4V7H20V9ZM16 12.999H4V10.999H16V12.999ZM4 17H12V15H4V17Z" fill={props.color} />
    </svg>
  );
}

SortIcon.propTypes = {
  color: PropTypes.string
};

SortIcon.defaultProps = {
  color: '#202020'
};